import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IRowData } from '../../../shared/models/list-models';
import { IDropdownOption } from '../../../shared/typings/interfaces/design-library.interface';

@Component({
  selector: 'shelter-network-settings-more-button',
  template: require('./shelter-network-settings-more-button.component.html'),
})
export class ShelterNetworkSettingsMoreButtonComponent implements OnInit {
  @Input() input: { row: IRowData[]; column: IRowData };
  @Output() output = new EventEmitter();
  options: IDropdownOption[];
  moreButtonDisabled: boolean = false;
  user: {
    id: string;
    name: string;
  };

  public ngOnInit() {
    const { row } = this.input;
    const accessLevel = this._getColumnFromKey({ row, columnKey: 'SHELTER_ACCESS_LEVEL' }).data;
    const userColumn = this._getColumnFromKey({ row, columnKey: 'STUB' });
    const moreColumn = this._getColumnFromKey({ row, columnKey: 'SHELTER_MORE' });
    const id = JSON.parse(userColumn.meta).data;
    const name = userColumn.data;
    this.user = { id, name };
    this.options = this._initDropdownOptions({ accessLevel, moreColumn });
    this.moreButtonDisabled = this._disableMoreBtn({ accessLevel, moreColumn });
  }

  // if the user's access level is not 'Yes' in the has access column, disable 'Edit portfolio' option
  // if the user can not be removed, disable 'Remove user' option
  private _initDropdownOptions({ accessLevel, moreColumn }): IDropdownOption[] {
    const { canBeRemoved } = JSON.parse(moreColumn.data);
    const editDetailOption = { key: 'Edit details', human: 'Edit details' };
    const editPortfolioOption =
      accessLevel === 'Yes'
        ? { key: 'Edit portfolio', human: 'Edit portfolio' }
        : { key: 'Edit portfolio', human: 'Edit portfolio', disabled: true };
    const removeUserOption = { key: 'Remove user', human: 'Remove user' };
    const options = canBeRemoved
      ? [editDetailOption, editPortfolioOption, removeUserOption]
      : [editDetailOption, editPortfolioOption];
    return options;
  }

  // if the user is 'Shelter Cluster Admin', or self
  // disable three dot menu (i.e. more button)
  private _disableMoreBtn({ accessLevel, moreColumn }): boolean {
    const { isSelf } = JSON.parse(moreColumn.data);
    if (accessLevel === 'Shelter Cluster Admin' || isSelf) {
      return true;
    }
    return false;
  }

  public onSelect(e): void {
    let action: string;
    switch (e) {
      case 'Edit details': {
        action = 'DETAILS';
        break;
      }
      case 'Edit portfolio': {
        action = 'PORTFOLIO';
        break;
      }
      case 'Remove user': {
        action = 'REMOVE';
        break;
      }
    }
    this.output.emit({ action, user: this.user });
  }

  private _getColumnFromKey({ row, columnKey }: { row: IRowData[]; columnKey: string }): IRowData {
    return row.find(v => v.columnKey === columnKey);
  }
}
